import classNames from 'classnames';
import { forwardRef, HTMLProps } from 'react';

import style from './checkbox.module.css';

export interface CheckboxProps extends Omit<HTMLProps<HTMLInputElement>, 'className' | 'type'> {
  containerClassName?: string;
  inputClassName?: string;
  label: string;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({
    containerClassName,
    inputClassName,
    label,
    ...inputProps
  }, ref) => {
    const inputLabel = inputProps.required && !label.endsWith('*')
      ? `${label} *`
      : label;

    return (
      <label className={classNames(style.label, containerClassName)}>
        <input
          className={classNames(
            style.checkboxInput,
            inputClassName,
          )}
          {...inputProps}
          ref={ref}
          type="checkbox"
        />

        {inputLabel}
      </label>
    );
  },
);

export default Checkbox;
